if (!customElements.get('menu-drawer')) {
    class MenuDrawer extends HTMLElement {
        constructor() {
            super();
        }

        connectedCallback() {
            // Select the correct drawer button.
            if (this.id === 'menu-drawer') {
                this.buttonMenuDrawer =
                    document.getElementById('button-menu-drawer');
            } else if (this.id === 'mobile-menu-drawer') {
                this.buttonMenuDrawer =
                    document.getElementById('button-mobile-menu-drawer');
            }

            if (!this.buttonMenuDrawer) return;

            this.drawerMenus = this.querySelectorAll('a');

            // Open or close drawer.
            this.buttonMenuDrawer.addEventListener('click', event => {
                event.preventDefault();
                this.onButtonMenuDrawerClick();
            });

            this.buttonMenuDrawer.addEventListener('keydown', event => {
                if (event.key === 'Enter') {
                    event.preventDefault();
                    this.onButtonMenuDrawerClick(true);
                }
            });

            // Close when the actual dark overlay is clicked.
            this.addEventListener(
                'click',
                this.onDrawerClick.bind(this)
            );

            // Close buttons.
            this.querySelectorAll('[data-close]').forEach(item => {
                item.addEventListener(
                    'click',
                    this.closeDrawer.bind(this)
                );

                item.addEventListener('keydown', event => {
                    if (event.key === 'Enter') {
                        event.preventDefault();
                        this.closeDrawer();
                    }
                });
            });

            // Close with Escape.
            this.addEventListener('keyup', event => {
                if (
                    event.key === 'Escape' ||
                    (
                        event.code &&
                        event.code.toUpperCase() === 'ESCAPE'
                    )
                ) {
                    this.closeDrawer();
                }
            });

            // Submenu buttons.
            this.querySelectorAll('[data-link-handler]').forEach(item => {
                item.addEventListener(
                    'click',
                    this.onLinkHandlerClick.bind(this)
                );

                item.addEventListener('focus', () => {
                    item.classList.remove('no-keyboard-focus');

                    item.addEventListener(
                        'blur',
                        () => {
                            item.classList.add(
                                'no-keyboard-focus'
                            );
                        },
                        { once: true }
                    );
                });
            });

            // Normal navigation links.
            this.querySelectorAll(
                'a:not([data-link-handler])'
            ).forEach(item => {
                item.addEventListener('focus', () => {
                    item.classList.remove('no-keyboard-focus');

                    item.addEventListener(
                        'blur',
                        () => {
                            item.classList.add(
                                'no-keyboard-focus'
                            );
                        },
                        { once: true }
                    );
                });
            });

            /*
             * Android Chrome changes the viewport height while
             * scrolling because the browser bars appear and disappear.
             *
             * Do not close the drawer for those height-only resize
             * events. Close the mobile drawer only when the layout
             * switches to desktop size.
             */
            window.addEventListener('resize', () => {
                const drawerIsOpen =
                    this.getAttribute('aria-hidden') === 'false';

                const desktopLayout =
                    window.innerWidth >= 1024;

                if (
                    this.id === 'mobile-menu-drawer' &&
                    drawerIsOpen &&
                    desktopLayout
                ) {
                    this.closeDrawer();
                }
            });

            // Country options.
            this.buttonCountries =
                this.querySelectorAll('.button--country');

            this.buttonCountries.forEach(item => {
                item.addEventListener('click', event => {
                    this.onLocalizationOptionClick(
                        event,
                        'menu-drawer-currency-form'
                    );
                });

                item.addEventListener('keydown', event => {
                    if (event.key === 'Enter') {
                        this.onLocalizationOptionClick(
                            event,
                            'menu-drawer-currency-form'
                        );
                    }
                });
            });

            // Language options.
            this.buttonLanguages =
                this.querySelectorAll('.button--language');

            this.buttonLanguages.forEach(item => {
                item.addEventListener('click', event => {
                    this.onLocalizationOptionClick(
                        event,
                        'menu-drawer-language-form'
                    );
                });

                item.addEventListener('keydown', event => {
                    if (event.key === 'Enter') {
                        this.onLocalizationOptionClick(
                            event,
                            'menu-drawer-language-form'
                        );
                    }
                });
            });

            // Initialize collection sliders.
            this.initializeSwipers();
        }

        onButtonMenuDrawerClick(isKeyboard = false) {
            this.previouslyFocusedElement =
                document.activeElement;

            const isOpening =
                this.getAttribute('aria-hidden') === 'true';

            if (!isOpening) {
                this.closeDrawer();
                return;
            }

            this.setAttribute('aria-hidden', 'false');
            this.removeAttribute('inert');

            if (this.buttonMenuDrawer) {
                this.buttonMenuDrawer.classList.add('active');
            }

            document.body.style.overflow = 'hidden';
            document.documentElement.style.overflow = 'hidden';

            if (typeof FocusTrap !== 'undefined') {
                FocusTrap.activate(this);
            }

            // Give focus to the first drawer link.
            if (this.drawerMenus.length > 0) {
                if (isKeyboard) {
                    this.drawerMenus[0].classList.remove(
                        'no-keyboard-focus'
                    );
                } else {
                    this.drawerMenus[0].classList.add(
                        'no-keyboard-focus'
                    );
                }

                setTimeout(() => {
                    if (
                        this.getAttribute('aria-hidden') === 'false'
                    ) {
                        this.drawerMenus[0].focus({
                            preventScroll: true
                        });
                    }
                }, 300);
            }
        }

        onDrawerClick(event) {
            /*
             * Only close when the event starts on the outer drawer
             * overlay itself. Touching or scrolling inside
             * .drawer__inner will not close it.
             */
            if (event.target === this) {
                this.closeDrawer();
            }
        }

        closeDrawer() {
            const isAlreadyClosed =
                this.getAttribute('aria-hidden') === 'true';

            if (isAlreadyClosed) return;

            if (typeof FocusTrap !== 'undefined') {
                FocusTrap.deactivate(this);
            }

            this.setAttribute('aria-hidden', 'true');
            this.setAttribute('inert', '');

            if (this.buttonMenuDrawer) {
                this.buttonMenuDrawer.classList.remove('active');
            }

            document.body.style.overflow = '';
            document.documentElement.style.overflow = '';

            // Return to the main menu for the next opening.
            const targetMenu = this.querySelector(
                '.menu--drawer[data-link-handle="-1"]'
            );

            if (targetMenu) {
                this.querySelectorAll('.menu--drawer').forEach(
                    item => {
                        item.classList.add('hidden');
                    }
                );

                targetMenu.classList.remove('hidden');
            }

            if (
                this.previouslyFocusedElement &&
                typeof this.previouslyFocusedElement.focus ===
                    'function'
            ) {
                this.previouslyFocusedElement.focus({
                    preventScroll: true
                });
            }
        }

        onLinkHandlerClick(event) {
            event.preventDefault();
            event.stopPropagation();

            const linkId =
                event.currentTarget.dataset.linkHandle;

            if (!linkId) return;

            const targetMenu = this.querySelector(
                `.menu--drawer[data-link-handle="${linkId}"]`
            );

            if (!targetMenu) return;

            this.querySelectorAll('.menu--drawer').forEach(item => {
                item.classList.add('hidden');
            });

            targetMenu.classList.remove('hidden');

            const targetMenuLinks =
                targetMenu.querySelectorAll('a');

            if (targetMenuLinks.length > 0) {
                targetMenuLinks[0].focus({
                    preventScroll: true
                });
            }
        }

        onLocalizationOptionClick(event, formId) {
            event.preventDefault();

            const option = event.currentTarget;
            const form = this.querySelector(`#${formId}`);
            const input = form
                ? form.querySelector('.input-locale')
                : null;

            if (input && form) {
                input.value = option.dataset.value;
                form.submit();
            }
        }

        async initializeSwipers() {
            this.swiperContainers =
                this.querySelectorAll('.swiper-container');

            if (this.swiperContainers.length === 0) return;

            if (typeof Swiper === 'undefined') {
                await new Promise(resolve => {
                    const check = () => {
                        if (typeof Swiper !== 'undefined') {
                            resolve();
                        } else {
                            requestAnimationFrame(check);
                        }
                    };

                    check();
                });
            }

            this.swiperContainers.forEach(swiperContainer => {
                const swiperSettings = {
                    init: false,
                    initialSlide: 0,
                    loop: false,
                    centeredSlides: false,
                    speed: 500,
                    watchOverflow: true,
                    slidesPerView: 1,
                    observer: true,
                    observeSlideChildren: true,
                    autoHeight: false,
                    spaceBetween: 30
                };

                const swiper = new Swiper(
                    swiperContainer,
                    swiperSettings
                );

                swiper.init();

                this.markDuplicateSlidesAsInert(swiper);

                swiper.on('slideChange', () => {
                    this.markDuplicateSlidesAsInert(swiper);
                });
            });

            this.setupFocusListeners();
        }

        markDuplicateSlidesAsInert(swiper) {
            swiper.slides.forEach(slide => {
                if (
                    slide.classList.contains(
                        'swiper-slide-duplicate'
                    )
                ) {
                    slide.setAttribute('inert', '');
                    slide.setAttribute('aria-hidden', 'true');
                }
            });
        }

        setupFocusListeners() {
            this.querySelectorAll(
                '.button-next, .button-previous'
            ).forEach(button => {
                button.addEventListener('focus', () => {
                    button.classList.add('focused');

                    button.addEventListener(
                        'blur',
                        () => {
                            button.classList.remove('focused');
                        },
                        { once: true }
                    );
                });
            });
        }
    }

    customElements.define('menu-drawer', MenuDrawer);
}